export * from './lib/animal-selection-animal-details-dialog.module';

export * from './lib/animal-selection-animal-details-dialog.component';
